<template>
    <div class="row" v-if="usefulLinks != ''">
        <div class="col-12">
 
            <div class="usefulLink">
                <div class="item" v-for="usefulLink in usefulLinks">
                    <a :title="usefulLink.Title" :href="usefulLink.Link" target="_Blank">
                        <img class="img-item" :src="usefulLink.PicPath" @error="imageLoadOnError" :alt="usefulLink.Title">
                        <span>{{usefulLink.Title}}</span>
                    </a>
                </div>
 
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            usefulLinks: function () {
                return this.$store.getters.readUsefulLinks;
            }
        },
        methods: {
            imageLoadOnError(event) {
                event.target.src = "/assets/img/no-image-available.png";
            },
        }
    }
</script>

<style scoped>
    .usefulLink a span {
        font-size:12px;
    }
    .usefulLink {
        /* margin-top:30px;
        margin-bottom:30px;*/
        display: flex;
        justify-content: center;
        align-items: center;
        padding-bottom: 10px;
        flex-wrap: wrap;
    }
        .usefulLink a {
            display: flex;
            flex-direction:column;
            justify-content: center;
            align-items: center;    
        }
        .usefulLink .item {
            margin: 5px 40px 20px 40px;
        }
        .usefulLink .item .img-item {
            margin-bottom:10px;
            width: 50px;
        }
       @media (max-width: 1300px) {
        .usefulLink {
            display: grid;
            grid-template-columns: repeat(4,minmax(0,3fr));
        }
 
        .usefulLink .item {
        margin: 5px 5px 5px 5px;
       }
    }
</style>